const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const tokenStore = {
  get: () => localStorage.getItem("cr_admin_token"),
  set: (t) => localStorage.setItem("cr_admin_token", t),
  clear: () => localStorage.removeItem("cr_admin_token"),
};

async function req(path, { method = "GET", body, auth = false } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (auth) {
    const token = tokenStore.get();
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let detail = "Request failed";
    try {
      const d = await res.json();
      detail = typeof d.detail === "string" ? d.detail : detail;
    } catch (_) {}
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res.status === 204 ? null : res.json();
}

export const api = {
  login: (email, password) => req("/auth/login", { method: "POST", body: { email, password } }),
  me: () => req("/auth/me", { auth: true }),
  getPublicAvailability: () => req("/rooms/availability"),
  getAdminRooms: () => req("/admin/rooms", { auth: true }),
  getMonthCalendar: (month) => req(`/admin/calendar?month=${month}`, { auth: true }),
  setCalendarRange: (roomIds, start, end, action, units, details = {}) =>
    req(`/admin/calendar/range`, { method: "PUT", auth: true, body: { room_ids: roomIds, start, end, action, units, ...details } }),
  getConfig: () => req("/admin/config", { auth: true }),
  setConfig: (prices, rate) => req("/admin/config", { method: "PUT", auth: true, body: { prices, rate } }),
  getDailyPrices: (month) => req(`/admin/daily-prices?month=${month}`, { auth: true }),
  setDailyPriceRange: (roomIds, start, end, price) =>
    req("/admin/daily-prices/range", { method: "PUT", auth: true, body: { room_ids: roomIds, start, end, price } }),
  getPricing: (checkin, checkout) =>
    req(checkin && checkout ? `/rooms/pricing?checkin=${encodeURIComponent(checkin)}&checkout=${encodeURIComponent(checkout)}` : "/rooms/pricing"),
  checkAvailability: (checkin, checkout) =>
    req(`/rooms/availability?checkin=${encodeURIComponent(checkin)}&checkout=${encodeURIComponent(checkout)}`),
  getLeads: () => req("/admin/leads", { auth: true }),
  setLeadStatus: (id, status) => req(`/admin/leads/${id}`, { method: "PATCH", auth: true, body: { status } }),
  createLead: (lead) => req("/leads", { method: "POST", body: lead }),
  vapidKey: () => req("/push/vapid-public-key"),
  subscribePush: (sub) => req("/push/subscribe", { method: "POST", auth: true, body: sub }),
  testPush: () => req("/push/test", { method: "POST", auth: true }),
};
